export const LOAD_ERROR_MESSAGE =
  'Something went wrong loading this data. Please try again.'

export const LOAD_ERROR_NOTIFICATION_INTERVAL = 5000

export const axiosClientConfig = {
  baseURL: window._env_?.REACT_APP_SERVER_URL ?? '',
  token: sessionStorage.getItem('token') ?? '',
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${sessionStorage.getItem('token') ?? ''}`,
  },
}

export const axiosClientRefreshConfig = {
  baseURL: window._env_.REACT_APP_SERVER_URL,
  token: sessionStorage.getItem('refreshToken') ?? '',
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${sessionStorage.getItem('refreshToken') ?? ''}`,
  },
}
